import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 33"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", { d: "M12 11.917a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M12 13.75c-6.416 0-9.166 4.583-9.166 11V33h18.333v-8.25c0-6.417-2.75-11-9.166-11" })
    ], -1)
  ]))]))
}
export default { render: render }